export default "__VITE_ASSET__281fb043__"